/** Chemins de navigation de l'objet Catalogue (mécanique de fiche par objet sur route). */

/** Base de la page "Configuration des offres commerciales". */
export const CATALOG_ADMIN_BASE = '/admin/offres';

/** Onglet du dashboard correspondant au listing des catalogues. */
export const CATALOG_TAB = 'catalogue';

/** Listing des catalogues (onglet du dashboard). */
export const catalogListPath = `${CATALOG_ADMIN_BASE}?tab=${CATALOG_TAB}`;

/** Fiche de création d'un catalogue. */
export const catalogCreatePath = `${CATALOG_ADMIN_BASE}/catalogue/new`;

/** Fiche d'édition d'un catalogue. */
export const catalogFichePath = (id: string | number): string =>
    `${CATALOG_ADMIN_BASE}/catalogue/${id}`;

/** Route enfant (relative à `admin/offres`) gérant création (`new`) et édition (`:id`). */
export const CATALOG_FICHE_ROUTE = 'catalogue/:id';
